import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
// fof/user-directory's hero, patched when its bundle registers it.
const USER_DIRECTORY_HERO = 'ext:fof/user-directory/forum/components/UserDirectoryHero';

/**
 * The user directory's hero reads like the other page heroes (hero.less
 * styles .UserDirectoryHero with them): the title without its address-book
 * icon, and a subtitle.
 */
export default function userDirectory() {
  extend(USER_DIRECTORY_HERO, 'contentItems', function (items) {
    if (items.has('user-directory-title')) {
      items.setContent('user-directory-title', m("h1", {
        className: "Hero-title"
      }, app.translator.trans('fof-user-directory.forum.hero.title')));
    }
    items.add('bdSubtitle', m("div", {
      className: "Hero-subtitle"
    }, app.translator.trans('bimmerdock-theme.forum.user_directory.subtitle')), 90);
  });
}